import client from "../graphqlClient";
import { getGraphqlResult } from "../../Utilities/Functions";
import {
  SEARCH_CHECK_REQUESTS,
  CREATE_CHECK_REQUESTS,
  UPDATE_ALLOCATION,
  CANCEL_REQUEST,
  RESTART_REQUEST,
  RESTART_COMPLETED_CHECK,
  REFER_TO_DEAL_TEAM,
  REFER_BACK_FROM_DEAL_TEAM,
} from "./graphql";

const searchCheckRequests = async (params) => {
  const { pageNumber = 0, rowsPerPage = 30, searchCriteria } = params;
  const response = await client.query({
    query: SEARCH_CHECK_REQUESTS,
    variables: {
      pageNumber,
      rowsPerPage,
      searchCriteria,
    },
    fetchPolicy: "no-cache",
  });
  const results = getGraphqlResult(response, "searchCheckRequests");

  return results;
};

const createCheckRequest = async (params) => {
  const { checkType, entityId, mdmId, dnbId, countryId, confidential } = params;
  const response = await client.query({
    query: CREATE_CHECK_REQUESTS,
    variables: {
      checkType,
      entityId,
      mdmId,
      dnbId,
      confidential,
      countryId,
    },
    fetchPolicy: "no-cache",
  });
  const results = getGraphqlResult(response, "createCheckRequest");
  return results;
};

const updateAllocation = async (params) => {
  const { requestId, allocatedEmail, allocatedUsername } = params;
  const response = await client.query({
    query: UPDATE_ALLOCATION,
    variables: {
      requestId,
      allocatedEmail,
      allocatedUsername,
    },
    fetchPolicy: "no-cache",
  });
  const results = getGraphqlResult(response, "allocateRequest");
  return results;
};

const cancelCheckRequest = async (params) => {
  const { requestId, cancelAssociations } = params;
  const response = await client.query({
    query: CANCEL_REQUEST,
    variables: {
      requestId,
      cancelAssociations,
    },
    fetchPolicy: "no-cache",
  });
  const results = getGraphqlResult(response, "cancelRequest");
  return results;
};

const restartCheckRequest = async (params) => {
  const { requestId } = params;
  const response = await client.query({
    query: RESTART_REQUEST,
    variables: {
      requestId,
    },
    fetchPolicy: "no-cache",
  });
  const results = getGraphqlResult(response, "restartRequest");
  return results;
};

const restartCompletedCheck = async (params) => {
  const { requestId } = params;
  const response = await client.query({
    query: RESTART_COMPLETED_CHECK,
    variables: {
      requestId,
    },

    fetchPolicy: "no-cache",
  });
  const results = await getGraphqlResult(response, "restartCompletedCheck");
  return results;
};

const referToDealTeam = async (params) => {
  const { entityId } = params;
  const response = await client.mutate({
    mutation: REFER_TO_DEAL_TEAM,
    variables: {
      entityId,
    },

    fetchPolicy: "no-cache",
  });
  const results = await getGraphqlResult(response, "referToDealTeam");
  return results;
};

const referBackFromDealTeam = async (params) => {
  const { entityId } = params;
  const response = await client.mutate({
    mutation: REFER_BACK_FROM_DEAL_TEAM,
    variables: {
      entityId,
    },

    fetchPolicy: "no-cache",
  });
  const results = await getGraphqlResult(response, "referBackFromDealTeam");
  return results;
};

export {
  searchCheckRequests,
  createCheckRequest,
  updateAllocation,
  cancelCheckRequest,
  restartCheckRequest,
  restartCompletedCheck,
  referToDealTeam,
  referBackFromDealTeam,
};
